import { useAuthStore } from './authStore';
import { useUserStore } from './userStore';
import { useMethodStore } from './methodStore';
import { useOnboardingStore } from './onboardingStore';
import { usePriceStore } from './priceStore';
import { useLocalizationStore } from './localizationStore';

export {
    useAuthStore,
    useIsLoggedIn,
    useAccessToken,
    useTokenExpiry,
    useSetIsLoggedIn,
    useSetAccessToken,
    useSetTokenExpiry,
    useResetAuth
} from './authStore';

export {
    useUserStore,
    useEmail,
    useSignupMethod,
    useIsVerified,
    useUserCountry,
    useMoneyType,
    useDisplayName,
    useUserIcon,
    useLinkId,
    useSetEmail,
    useSetSignupMethod,
    useSetIsVerified,
    useSetUserCountry,
    useSetMoneyType,
    useSetDisplayName,
    useSetUserIcon,
    useSetLinkId,
    useResetUser
} from './userStore';

export {
    useMethodStore,
    useLink,
    useQrCode,
    useQrCodeLink,
    useButtonCode,
    useButtonId,
    useSetLink,
    useSetStripeLink,
    useSetQrCode,
    useSetQrCodeLink,
    useSetButtonCode,
    useSetButtonId,
    useResetMethod,
} from './methodStore';

export {
    useOnboardingStore,
    useCryptoOnboardingComplete,
    useOnboardingStage,
    useHasStripeAccount,
    useContinueFiatOnboarding,
    useStripeOnboardingStatus,
    useSetCryptoOnboardingComplete,
    useSetOnboardingStage,
    useSetHasStripeAccount,
    useSetContinueFiatOnboarding,
    useSetStripeOnboardingStatus,
    useResetOnboarding
} from './onboardingStore';

export {
    usePriceStore,
    usePriceCurrency,
    useMinimumPrice,
    usePresetPrice,
    useSetPriceCurrency,
    useSetMinimumPrice,
    useSetPresetPrice,
    useResetPrice
} from './priceStore';

export {
    useLocalizationStore,
    useLocale,
    useIsAmerican,
    useIsBritish,
    useSetLocale,
    useToggleLocale,
    useSpell,
    useLocalize,
    useT
} from './localizationStore';

export const resetApp = () => {
    useAuthStore.getState().resetAuth();
    useUserStore.getState().resetUser();
    useMethodStore.getState().resetMethod();
    useOnboardingStore.getState().resetOnboarding();
    usePriceStore.getState().resetPrice();
    useLocalizationStore.getState().resetLocalization();
};
